import { AbstractModel } from '../shared/abstract.model';

export class FormDataModel extends AbstractModel {
  public formName: string;
  public payload: any;

  constructor() {
    super();
    this.formName = '';
    this.payload = {};
  }
}
